import {useRef, useState} from 'react';

import {Button} from 'shells/button/button';

import {AiFeatureType, LimitedType} from 'nutshell-graphql-types';

import {AiFeatureGateModal} from '../../ai-home/ai-feature-gate-modal/ai-feature-gate-modal';
import {useGetLimitsByType} from '../../limits/use-get-limits-by-type';

import {AiButtonContent} from '../ai-button-content';
import {useGetPowerAiSummarizationMonthlyUsage} from '../power-ai-usage-popover/graphql/hooks';

interface Props {
    onGenerateEntitySummary: () => void;
}

export function SummaryGenerateButton(props: Props) {
    const buttonRef = useRef(null);
    const [isGateModalOpen, setIsGateModalOpen] = useState(false);

    const hasAiOutcomes = NutClientConfig.hasAiOutcomesFF;

    const limitsType = hasAiOutcomes ? LimitedType.AI_OUTCOMES : LimitedType.AI_SUMMARIES;
    const {limits, isLoading: isLoadingLimits} = useGetLimitsByType(limitsType);
    const {monthlyUsage} = useGetPowerAiSummarizationMonthlyUsage();

    const isOutOfCredits = limits
        ? !limits.canAdd
        : !monthlyUsage || (monthlyUsage && monthlyUsage.remaining === 0);

    const handleClick = () => {
        if (hasAiOutcomes && isOutOfCredits) {
            setIsGateModalOpen(true);

            return;
        }

        props.onGenerateEntitySummary();
    };

    return (
        <>
            <Button
                getButtonRef={buttonRef}
                variant='ai-blue'
                size='big'
                disabled={(!hasAiOutcomes && isOutOfCredits) || isLoadingLimits}
                onClick={handleClick}
            >
                <AiButtonContent buttonText='Summarize' buttonRef={buttonRef} />
            </Button>
            <AiFeatureGateModal
                isOpen={isGateModalOpen}
                onClose={() => setIsGateModalOpen(false)}
                reason='outOfCredits'
                aiFeatureType={AiFeatureType.TIMELINE_SUMMARIZER}
            />
        </>
    );
}
